var map = {
	"./element-icons-72-x-72-ic-rating-content-dialogue.svg": "6347",
	"./element-icons-72-x-72-ic-rating-content-drug.svg": "fed5",
	"./element-icons-72-x-72-ic-rating-content-horror.svg": "885b",
	"./element-icons-72-x-72-ic-rating-content-imitation.svg": "8157",
	"./element-icons-72-x-72-ic-rating-content-sexuality.svg": "283a",
	"./element-icons-72-x-72-ic-rating-content-theme.svg": "6f15",
	"./element-icons-72-x-72-ic-rating-content-violence.svg": "93a4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "baad";